/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    DESIGN_CATEGORIES_title: "Catégories de modèles",
    DESIGN_CATEGORIES_label: "catégorie",
    DESIGN_CATEGORIES_pluralLabel: "catégories",
    DESIGN_CATEGORIES_description:
        "Les rubriques de la bibliothèque de modèles du logiciel : pages web, sections, " +
        "pop-ups, e-mails et Studio. Chaque catégorie appartient à un type et se nomme dans " +
        "chaque langue ; le français s'affiche quand la langue de l'utilisateur n'est pas " +
        "remplie.",
    DESIGN_CATEGORIES_create: "Ajouter une catégorie",
    DESIGN_CATEGORIES_createTitle: "Ajouter une catégorie",
    DESIGN_CATEGORIES_editTitle: "Modifier la catégorie",
    DESIGN_CATEGORIES_save: "Enregistrer",
    DESIGN_CATEGORIES_allTypes: "Tous les types",
    DESIGN_CATEGORIES_type_3: "Pages web",
    DESIGN_CATEGORIES_type_6: "Sections",
    DESIGN_CATEGORIES_type_5: "Pop-ups",
    DESIGN_CATEGORIES_type_4: "E-mails",
    DESIGN_CATEGORIES_type_2: "Studio",
    DESIGN_CATEGORIES_columnName: "Nom",
    DESIGN_CATEGORIES_columnType: "Type",
    DESIGN_CATEGORIES_columnOrder: "Ordre",
    DESIGN_CATEGORIES_columnLocales: "Langues",
    DESIGN_CATEGORIES_actionEdit: "Modifier",
    DESIGN_CATEGORIES_actionDelete: "Supprimer",
    DESIGN_CATEGORIES_fieldType: "Type de modèle",
    DESIGN_CATEGORIES_fieldTypePlaceholder: "Choisir un type",
    DESIGN_CATEGORIES_fieldOrder: "Ordre",
    DESIGN_CATEGORIES_orderHelp:
        "Les catégories s'affichent de l'ordre le plus petit au plus grand ; sans ordre, à la " +
        "fin.",
    DESIGN_CATEGORIES_fieldName: "Nom ({locale})",
    DESIGN_CATEGORIES_namesHelp:
        "Le français est obligatoire. Une langue laissée vide garde son nom actuel.",
    DESIGN_CATEGORIES_deleteConfirm:
        "Supprimer la catégorie « {name} » ({type}) ? C'est définitif.",
    DESIGN_CATEGORIES_created: "La catégorie a été ajoutée.",
    DESIGN_CATEGORIES_updated: "La catégorie a été modifiée.",
    DESIGN_CATEGORIES_reordered: "La catégorie a été déplacée.",
    DESIGN_CATEGORIES_dragHint:
        "Glissez une ligne pour changer l'ordre d'affichage des catégories de ce type.",
    DESIGN_CATEGORIES_pickTypeToReorder:
        "Choisissez un type pour changer l'ordre d'affichage en glissant les lignes.",
    DESIGN_CATEGORIES_deleted: "La catégorie a été supprimée.",
    DESIGN_CATEGORIES_emptyTitle: "Aucune catégorie",
    DESIGN_CATEGORIES_emptyDescription: "Ajoutez la première avec « Ajouter une catégorie ».",
    DESIGN_CATEGORIES_loadFailedTitle: "Liste indisponible",
    DESIGN_CATEGORIES_loadFailed:
        "La liste des catégories n'a pas pu être chargée. Réessayez plus tard."
};
